const namespace = 'presto-player.progress';
let visit_time = Date.now();
let nonce;

/**
 * Sends an updated ajax progress event for plugins to hook into
 */
export default player => {
  // automations are disabled
  if (!player.automations) {
    return;
  }

  // set nonce when fetched
  if (!window?.wp?.hooks?.hasAction('presto.nonceRefreshed', namespace)) {
    window.wp.hooks.addAction('presto.nonceRefreshed', namespace, newNonce => {
      nonce = newNonce;
    });
  }

  // on time update, maybe send time update
  window?.wp.hooks.addAction('presto.playerTimeUpdate', 'presto-player', sendTimeUpdate);
  // be sure to mark complete on end
  window?.wp.hooks.addAction('presto.playerEnded', 'presto-player', plyr => sendTimeUpdate(plyr, 100));

  let watched = {
    0: false,
    10: false,
    20: false,
    30: false,
    40: false,
    50: false,
    60: false,
    70: false,
    80: false,
    90: false,
    100: false,
  };

  function sendTimeUpdate(player, percent = null) {
    // need to send nonce
    if (!nonce) {
      return;
    }

    // bail if progress is not turned on
    if (!player?.config?.ajaxProgress) {
      return;
    }

    if (!percent) {
      percent = (parseFloat(player.currentTime) / parseFloat(player.duration)) * 100;
    }

    player.watched = player.watched || {};
    Object.keys(watched).forEach(m => {
      const marker = parseInt(m);
      if (!player.watched[marker] && percent >= marker) {
        player.watched[marker] = true;

        let formData = new FormData();

        formData.append('action', 'presto_player_progress_percent');
        formData.append('id', player?.config?.id);
        formData.append('percent', marker.toString());
        formData.append('visit_time', visit_time.toString());
        formData.append('nonce', nonce);

        if (window?.prestoPlayer?.debug) {
          console.log(`${marker} percent watched.`);
        }

        if (!window?.prestoPlayer?.debug_navigator) {
          let result = navigator.sendBeacon(window?.prestoPlayer?.ajaxurl, formData);
          if (window?.prestoPlayer?.debug) {
            if (result) {
              console.log('Successfully queued progress:', {
                id: player?.config?.id,
                percent: marker,
                visit_time,
                nonce,
              });
            } else {
              console.log('Failed to queue progress', {
                id: player?.config?.id,
                percent: marker,
                visit_time,
                nonce,
              });
            }
          }
        } else {
          window.jQuery.ajax({
            type: 'POST',
            url: window?.prestoPlayer?.ajaxurl,
            dataType: 'json',
            cache: false,
            data: {
              action: 'presto_player_progress_percent',
              id: player?.config?.id,
              visit_time,
              percent: marker,
              nonce,
            },
          });
        }
      }
    });
  }
};
